import { ITender } from 'types/tender';
import { useCallback, useEffect, useState } from 'react';
import { hasTenderPassedDocDeadline } from 'utils/tender';

export function useTenderPassedDocDeadline(tender?: ITender) {
  const [passedDeadline, setPassedDeadline] = useState(true);

  const checkDate = useCallback(() => {
    if (tender?.docSubmissionDeadline) {
      setPassedDeadline(hasTenderPassedDocDeadline(tender))
    }
  }, [tender?.docSubmissionDeadline])

  useEffect(() => {
    const intervalId = setInterval(checkDate, 1000);

    return () => {
      clearInterval(intervalId)
    }
  }, [checkDate])

  return passedDeadline;
}
